/* Kaffepro 2027 – the front page's best sellers by the circle's stops (sections/ks-home-best.liquid, round 7). All rows are in the page from
   the start; this only switches the tabs (an ARIA tablist: click, ←/→, Home, End) and pages the row with the arrows, four cards at a time on
   a computer (the phone swipes). ES5, no dependencies; once per section, again when the theme editor reloads it. */
(function () {
  'use strict';
  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }

  function init(root) {
    if (!root || root.__ksBest) return; root.__ksBest = 1;
    var tabs = root.querySelectorAll('[role="tab"]'), panels = root.querySelectorAll('[role="tabpanel"]'), more = root.querySelectorAll('[data-ks-best-more]');
    var prev = root.querySelector('[data-ks-best-step="-1"]'), next = root.querySelector('[data-ks-best-step="1"]');
    var cur = 0, raf = 0;
    if (!tabs.length) return;
    each(tabs, function (t, i) { if (t.getAttribute('aria-selected') === 'true') cur = i; });

    function rail() { return panels[cur] ? panels[cur].querySelector('.ks-best__rail') : null; }
    function arrows() {
      raf = 0; if (!prev || !next) return;
      var r = rail(), max = r ? r.scrollWidth - r.clientWidth : 0, x = r ? r.scrollLeft : 0;
      prev.hidden = next.hidden = max <= 2;
      prev.disabled = x <= 2; next.disabled = x >= max - 2;
      if (r) { prev.setAttribute('aria-controls', r.id); next.setAttribute('aria-controls', r.id); }
    }
    function later() { if (!raf) raf = window.requestAnimationFrame ? window.requestAnimationFrame(arrows) : setTimeout(arrows, 16); }
    function select(i, focus) {
      if (i < 0) i = tabs.length - 1; else if (i >= tabs.length) i = 0;
      each(tabs, function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
      each(panels, function (p, j) { p.hidden = j !== i; });
      each(more, function (a, j) { a.hidden = j !== i; });
      cur = i;
      var r = rail(); if (r) r.scrollLeft = 0;
      arrows();
      if (focus) tabs[i].focus();
    }
    each(tabs, function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key || e.keyCode, to = null;
        if (k === 'ArrowRight' || k === 'Right' || k === 39) to = i + 1;
        else if (k === 'ArrowLeft' || k === 'Left' || k === 37) to = i - 1;
        else if (k === 'Home' || k === 36) to = 0;
        else if (k === 'End' || k === 35) to = tabs.length - 1;
        if (to === null) return;
        e.preventDefault(); select(to, true);
      });
    });
    function step(dir) {
      var r = rail(); if (!r) return;
      var gap = parseFloat((window.getComputedStyle(r).columnGap || '0')) || 0, by = dir * (r.clientWidth + gap);
      if (typeof r.scrollBy === 'function') r.scrollBy({ left: by, behavior: 'smooth' }); else r.scrollLeft += by;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    each(panels, function (p) { var r = p.querySelector('.ks-best__rail'); if (r) r.addEventListener('scroll', later); });
    window.addEventListener('resize', later);
    arrows();
  }

  function boot() { each(document.querySelectorAll('[data-ks-best]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector) init(e.target.querySelector('[data-ks-best]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target, root = t && t.closest ? t.closest('[data-ks-best]') : null;
    if (root && t.getAttribute('role') === 'tab') t.click();
  });
})();
